module.exports = __webpack_public_path__ + "static/paragraph-1-330e51806126e33c17437a3b89a067b5.svg";